import { Box, Link } from '@sequencehq/core-components'
import {
  amendmentLockSentenceStart,
  LockedScheduleAction
} from 'common/components/ScheduleAmendmentLock/scheduleAmendmentLock.constants'
import type { ScheduleAmendmentLock } from 'common/components/ScheduleAmendmentLock/useScheduleAmendmentLock'
import { FC } from 'react'

type Props = {
  action: LockedScheduleAction
  lock: ScheduleAmendmentLock
  'data-testid'?: string
}

/**
 * Why the schedule is locked, with the quote name linking through to the quote.
 * The colour is inherited so the same sentence reads correctly on the dark
 * tooltip in the schedule home and on the warning banner in the editor.
 */
export const ScheduleAmendmentLockMessage: FC<Props> = ({
  action,
  lock,
  'data-testid': dataTestId
}) => (
  <Box data-testid={dataTestId}>
    {amendmentLockSentenceStart(action)}
    {lock.isQuoteNameKnown && lock.quoteId ? (
      <Link
        to={`/quotes/${lock.quoteId}`}
        color="inherit"
        textDecoration="underline"
        data-testid={dataTestId ? `${dataTestId}.quoteLink` : undefined}
      >
        {lock.quoteName}
      </Link>
    ) : (
      lock.quoteName
    )}
    .
  </Box>
)
